import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {
    selectPreSelectedParlayById, selectPrizeAssetById,
    selectSelectedParlayId,
    selectUserParlayById
} from "../../stores/pickX/pickX.selectors";
import {useEffect, useRef} from "react";
import pickXApi from "../../stores/pickX/pickX.api";
import {createFromPreSelectedParlay} from "../../stores/pickX/pickX.thunks";
import {setSelectedParlayId} from "../../stores/pickX/pickX.slice";
import {ModalType} from "../../components/AppModal/ModalTypes";
import PrizeAssetWelcomePopUp from "../PopUps/WelcomePopUps/PrizeAssetWelcomePopUp";
import useAppModalService from "../../hooks/useAppModalService";
import GenericWelcomePopUp from "../PopUps/WelcomePopUps/GenericWelcomePopUp";

const usePicksViewModel = ()=>{

    const modalServices = useAppModalService();
    const dispatch = useDispatch();
    const selectedParlayId = useSelector(selectSelectedParlayId);
    const preSelectedParlayId = useParams().parlayId;

    const userParlayId = "newFrom_" + preSelectedParlayId;
    const preSelectedParlay = useSelector((state) => selectPreSelectedParlayById(state, preSelectedParlayId));
    const userParlay = useSelector(state=>selectUserParlayById(state, userParlayId));

    const initiated = useRef( {preSelectedParlay: preSelectedParlay != null,
                                      userParlay: userParlay != null });

    const isPrizeAsset = !!preSelectedParlay?.PrizeAssetId
    const prizeAsset = useSelector(state=> selectPrizeAssetById(state, preSelectedParlay?.PrizeAssetId));


    useEffect(() => {
        if(!initiated.current.preSelectedParlay) {
            initiated.current.preSelectedParlay = true;
            if (!preSelectedParlay) {
                dispatch(pickXApi.endpoints.getPreSelectedParlayById.initiate(preSelectedParlayId));
            }
        }
        else if(preSelectedParlay && !initiated.current.userParlay){
            initiated.current.userParlay = true;
            dispatch(createFromPreSelectedParlay({userParlayId, preSelectedParlayId}));

            if(preSelectedParlay.PrizeAssetId){
                modalServices.openModal('prizeAssetWelcomePopUp', ModalType.CUSTOM, {
                    modalComponent: PrizeAssetWelcomePopUp,
                    onOk: () => {
                        //navigate('/lobby');
                    }
                }, {
                    preSelectedParlay
                })
            }else{
                modalServices.openModal('genericWelcomePopUp', ModalType.CUSTOM, {
                    modalComponent: GenericWelcomePopUp,
                    onOk: () => {
                        //navigate('/lobby');
                    }
                }, {
                    preSelectedParlay
                })
            }

        }

        if (userParlay && (selectedParlayId == null || userParlay.Id !== selectedParlayId))
            dispatch(setSelectedParlayId(userParlay.Id));
    }, [preSelectedParlay ]);

    return {
        preSelectedParlay,
        userParlay,
        isPrizeAsset,
        prizeAsset
    };
}
export default usePicksViewModel;